module.exports = {"id":"198710","name":"James Rodríguez","rating":"86","photo":"./data/images/photos/3/198710.png","club":{"name":"FC Bayern","logo":"./data/images/clubs/FCBayern.png"},"positions":["MOC","MC","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JamesRodriguez0.json
// module id = 1901
// module chunks = 0